import Vue from "vue";

import CommaInput from "@/components/CommaInput.vue";
import NumberInput from "@/components/NumberInput.vue";
import MonthPicker from "@/components/MonthPicker.vue";
import LinkInput from "@/components/LinkInput.vue";
import MaxLengthInput from "@/components/MaxLengthInput.vue";
import MaxLengthTextarea from "@/components/MaxLengthTextarea.vue";
import MaxLengthEditor from "@/components/MaxLengthEditor.vue";
import HyphenInput from "@/components/HyphenInput.vue";
import RadioTypeCheck from "@/components/radio/RadioTypeCheck.vue";

import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import FileUploadModule from "@/views/modules/FileUploadModule";
import DateSelector from "@/components/selector/DateSelector";

Vue.component("CommaInput", CommaInput);
Vue.component("NumberInput", NumberInput);
Vue.component("MonthPicker", MonthPicker);
Vue.component("MlInput", MaxLengthInput);
Vue.component("MlTextarea", MaxLengthTextarea);
Vue.component("MlEditor", MaxLengthEditor);
Vue.component("HyphenInput", HyphenInput);
Vue.component("RadioTypeCheck", RadioTypeCheck);
Vue.component("LinkInput", LinkInput);

Vue.component("FieldSelectModule", FieldSelectModule);
Vue.component("PhotoUploadGridModule", PhotoUploadGridModule);
Vue.component("FileUploadModule", FileUploadModule);
Vue.component("DateSelector", DateSelector);
